import React from 'react';
import { SummaryProps, Section, Subsection, Item } from './types';
import Panel from "@sharedComponents/Panel";

export const Summary = (props: SummaryProps) => {
    return (
        <>
            {props.sections.map((section: Section, i: number) => (
                <React.Fragment key={i}>
                    <h4>{section.title}</h4>
                    <div className='summary-panel-container'>
                        <Panel type="info">
                            <div className='preview-section-wrapper'>
                                {(section.subsections || [])
                                    .filter(
                                        (subsection: Subsection) =>
                                            !subsection.hidden
                                    )
                                    .map(
                                        (subsection: Subsection, j: number) => {
                                            const single = subsection.items && subsection.items.length === 1;
                                            return (
                                            <div className='preview-section-wrapper__item-wrapper'
                                                key={j}>
                                                {subsection.title && (
                                                    <div className='preview-section-wrapper__sub-heading'>
                                                        <span>
                                                            {subsection.title}
                                                        </span>
                                                    </div>
                                                )}
                                                {(subsection.items || [])
                                                    .filter(
                                                        (item: Item) =>
                                                            !item.hidden
                                                    )
                                                    .map(
                                                        (
                                                            item: any,
                                                            k: number
                                                        ) => (
                                                            <div className={`preview-section-wrapper__item 
                                                                ${!!subsection.slim && !single ? 'preview-section-wrapper__item--slim' : ''}
                                                                ${single ? 'preview-section-wrapper__item--single' : ''}`}
                                                                key={k}>
                                                                <div className='preview-section-wrapper__item-heading'>
                                                                    {item.title}
                                                                </div>
                                                                <span>
                                                                    {item.value ||
                                                                        '—'}
                                                                </span>
                                                            </div>
                                                        )
                                                    )}
                                            </div>
                                        )}
                                    )}
                            </div>
                        </Panel>
                    </div>
                </React.Fragment>
            ))}
        </>
    )
}

export default Summary;